// proxy handlers for returning default values
// in various situations
// details on how proxies work
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy
export const getFunctionHandler = {
    get: (target, prop, receiver) => {
        if (!target[prop]) {
            // eslint-disable-next-line  no-null/no-null
            return () => null;
        }
        return Reflect.get(target, prop, receiver);
    }
};
export const getVariantHandler = {
    get: (target, prop, receiver) => {
        if (!target[prop]) {
            return "default";
        }
        return Reflect.get(target, prop, receiver);
    }
};
export const mapHandler = {
    get: (target, prop, receiver) => {
        if (typeof target[prop] !== "object") {
            return new Proxy({}, getFunctionHandler);
        }
        return Reflect.get(target, prop, receiver);
    }
};
export const getStatusHandler = {
    get: (target, prop, receiver) => {
        if (!target[prop]) {
            return "";
        }
        return Reflect.get(target, prop, receiver);
    }
};
export const getBonusMessagesHandler = {
    get: (target, prop, receiver) => {
        if (!target[prop]) {
            return [];
        }
        return Reflect.get(target, prop, receiver);
    }
};
//# sourceMappingURL=ProxyHandlers.js.map